exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-picker[data-v-33e0cf8c]{position:relative}.vc-chrome[data-v-33e0cf8c]{position:absolute;top:60px;left:0;z-index:9}", ""]);

// exports
